import { Diagnostic } from "@ionic-native/diagnostic";
import { isCapacitorPlatform } from "@src/appV2/lib/utils/capacitor/platformUtils";

export const requestLocationAccess = async () => {
  const locationStatus = (await Diagnostic.getLocationAuthorizationStatus()) as string;

  if (locationStatus !== Diagnostic.permissionStatus.NOT_REQUESTED) {
    return;
  }

  await Diagnostic.requestLocationAuthorization();
};

export const requestFullLocationAccess = async () => {
  if (!isCapacitorPlatform()) {
    return;
  }

  await requestLocationAccess();
  await Diagnostic.switchToSettings();
};
